var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"margin-right-15 margin-top-15",staticStyle:{"text-align":"right"}},[(
                _vm.alltype != 'query' &&
                _vm.alltype != 'priceA' &&
                _vm.alltype != 'improve'
            )?_c('vButton',{attrs:{"theme":"primary"},on:{"click":_vm.addItem}},[_vm._v(_vm._s(_vm.$t("global.common.add_detail", { defaultValue: "添加详细" })))]):_vm._e()],1),_c('vTable',{ref:"table",staticClass:"margin-left-10 margin-right-10 margin-top-15",attrs:{"columns":_vm.columns,"data":_vm.formList,"size":"small","border":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }